export default function AddressItem(props: {
  address: any
  contacts: {
    telephone: string | null
    email: string | undefined
  }
  addressIndex: number
  selected: boolean
  handleSelected: () => void
}) {
  return (
    <div
      className={`flex mt-3 flex-row justify-center w-full border address-item rounded-2xl hover:cursor-pointer ${
        props.selected ? "border-2 bg-[#f2f2e4]" : "border"
      }`}
      onClick={props.handleSelected}
    >
      <div className="max-w-[2rem] grow flex items-center justify-center w-full rounded-l-2xl p-3">
        <input
          checked={props.selected}
          type="radio"
          onChange={props.handleSelected}
        />
      </div>
      <div className="w-full pl-3">
        <h2 className="font-medium">
          {props.address.first_name} {props.address.last_name}
        </h2>
        <p className="italic text-gray-500">
          {props.address.address_1} {props.address.address_2}{" "}
          {props.address.city}, {props.address.postal_code}
        </p>
        <br />
        <p className="italic text-gray-500">
          Společnost / Pobočka: {props.address.company}
        </p>
        <p className="italic text-gray-500">
          Telefon: {props.address.telephone || props.contacts.telephone}
        </p>
        <p className="italic text-gray-500">E-mail: {props.contacts.email}</p>
      </div>
    </div>
  )
}
